import axios from 'axios';
let base = '/api';
//用户登录
export const requestLogin = params => { return axios.post(`${base}/user/login`, params).then(res => res.data); };
//获取客户列表
export const getCustomerList = params => { return axios.get(`${base}/customers`, { params: params }).then(res => res.data); };
//添加客户
export const addCustomer = params => { return axios.post(`${base}/customers`, params).then(res => res.data); };
//修改客户
export const updateCustomer = params => { return axios.put(`${base}/customers/${params.cust_id}`, params).then(res => res.data); };
//删除客户
export const deleteCustomer = params => { return axios.delete(`${base}/customers/${params}`).then(res => res.data); };

//获取产品列表
export const getProductList = params => { return axios.get(`${base}/products`, { params: params }).then(res => res.data); };
//添加产品
export const addProduct = params => { return axios.post(`${base}/products`, params).then(res => res.data); };
//修改产品
export const updateProduct = params => { return axios.put(`${base}/products/${params.prod_id}`, params).then(res => res.data); };
//删除产品
export const deleteProduct = params => { return axios.delete(`${base}/products/${params}`).then(res => res.data); };

//获取授权列表
export const getAuthorityList = params => { return axios.get(`${base}/authority`, { params: params }).then(res => res.data); };
//添加授权
export const addAuthority = params => { return axios.post(`${base}/authority`, params).then(res => res.data); };
//修改授权
export const updateAuthority = params => { return axios.put(`${base}/authority/${params.auth_code}`, params).then(res => res.data); };
//删除授权
export const deleteAuthority = params => { return axios.delete(`${base}/authority/${params}`).then(res => res.data); };
//获取产品-客户列表
export const getCustProdcut = params => { return axios.get(`${base}/authority/cust_product`).then(res => res.data); };
//解绑授权
export const unbindAuthority = params => { return axios.get(`${base}/authority/unbind/${params}`).then(res => res.data); };

// 获取设备信息
export const getDeviceInfo = params => { return axios.get(`${base}/devices/devicesDetail`, {params: params}).then(res => res.data); };

// 获取子用户，父级ID
export const getSubUserList = params => { return axios.get(`${base}/customers/CustomListByCustId`, {params: params}).then(res => res.data); };
// 名字查询用户
export const getCustomListByName = params => { return axios.get(`${base}/customers/CustomListByName`, {params: params}).then(res => res.data); };



// WEBPACK FOOTER //
// ./src/api/index.js